import React, { useState } from 'react';
import { Video } from 'lucide-react';
import { UniversalVideoSession } from '../../templates/universal/UniversalVideoSession';

interface VideoConnectHostProps {
  sessionId: string;
  roomId?: string;
  hostName?: string;
}

export const VideoConnectHost: React.FC<VideoConnectHostProps> = ({ sessionId, roomId, hostName }) => {
  const [sessionStarted, setSessionStarted] = useState(false);
  const [name, setName] = useState('');

  // Parse URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const finalRoomId = roomId || urlParams.get('roomId') || '';
  const finalHostName = hostName || urlParams.get('hostName') || '';

  const handleJoinCall = () => {
    if (!name.trim()) {
      return;
    }
    setSessionStarted(true);
  };

  if (sessionStarted) {
    return (
      <div className="min-h-screen bg-gray-900">
        <UniversalVideoSession
          roomId={finalRoomId}
          requestId={sessionId}
          agentName={name}
          participantType="host"
          customerName="Guest"
          sessionDetails={{
            title: 'Video Call',
            category: 'video-connect',
            urgency: 'medium',
            description: 'Video connect session'
          }}
          isDemo={true}
          hideSidebar={true}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-4">
            <Video className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Join Call
          </h1>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Your Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder={finalHostName || "Enter your name"}
              maxLength={50}
            />
          </div>

          <button
            onClick={handleJoinCall}
            disabled={!name.trim()}
            className="w-full bg-blue-600 text-white py-4 px-6 rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
          >
            <Video className="w-5 h-5 mr-2" />
            Join Call
          </button>
        </div>
      </div>
    </div>
  );
};
